export default __webpack_public_path__ + "static/media/popup_close_icon.8dc51e99.svg";